import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSupportTemplatesApi } from 'api/support-templates-api';
import toast from 'react-hot-toast';
import { getErrorString } from 'utils';

export const fetchSupportTemplates = createAsyncThunk('templates/support', async () => {
  try {
    const paramsObj = {
      'q[s]': 'updated_at desc',
      per_page: 100,
    };

    const res = await fetchSupportTemplatesApi({ paramsObj });
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const SupportTemplatesSlice = createSlice({
  name: 'supportTemplates',
  initialState: {
    loading: false,
    supportTemplates: [],
  },
  reducers: {
    addUpdateSupportTemplate: (state, action) => {
      const newTemplate = action.payload;
      const existingTemplate = state.supportTemplates.find((item) => item.id === newTemplate?.id);

      if (existingTemplate) {
        Object.assign(existingTemplate, newTemplate);
      } else {
        state.supportTemplates.unshift(newTemplate);
      }
    },
    deleteSupportTemplate: (state, { payload }) => {
      state.supportTemplates = state.supportTemplates.filter((temp) => temp?.id != payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupportTemplates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSupportTemplates.fulfilled, (state, { payload }) => {
        state.supportTemplates = payload?.data;
        state.loading = false;
      })
      .addCase(fetchSupportTemplates.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setActiveConversation, addUpdateSupportTemplate, deleteSupportTemplate } = SupportTemplatesSlice.actions;
export default SupportTemplatesSlice.reducer;
